const useGtmId = () => {
  const gtmId = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;

  return gtmId ? gtmId : null;
};

export default useGtmId;
